import React, { memo } from "react";
import { FormControl, FormLabel, FormErrorMessage } from "@chakra-ui/react";
import SSNMaskedInput from "components/SSNMaskedInput/index.jsx";
import { Field, useField } from "formik";

function SSNField({ name, label, ...rest }) {
  const [field, meta, helpers] = useField(name);

  return (
    <Field name={name}>
      {() => (
        <FormControl isInvalid={meta.touched && meta.error}>
          {label && <FormLabel htmlFor={name}>{label}</FormLabel>}
          <SSNMaskedInput
            id={name}
            name={name}
            value={field.value || ""}
            onChange={(raw) => helpers.setValue(raw)}
            onBlur={() => helpers.setTouched(true)}
            {...rest}
          />
          <FormErrorMessage>{meta.error}</FormErrorMessage>
        </FormControl>
      )}
    </Field>
  );
}

export default memo(SSNField);
